import React from 'react';
import Moment from 'react-moment';

import Grid from '@material-ui/core/Grid';
import { InnerCard } from '../InnerCard';
import { Info } from '../Info';
import { Status } from '../Status';
import { ThirdPartyLink } from '../ThirdPartyLink';
import { HistoryDialog } from '../HistoryDialog';
import { AlfaMessageDialog } from '../AlfaMessageDialog';

export class ThirdPartyCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            role: null
        };
    }

    componentDidMount() {
        this.updateRole(this.props.quote, this.props.thirdParty);
    }

    componentDidUpdate(prevProps) {
        if (this.props.quote !== prevProps.quote || this.props.thirdParty !== prevProps.thirdParty) {
            this.updateRole(this.props.quote, this.props.thirdParty);
        }
    }

    updateRole(quote, thirdParty) {
    
        if (quote && thirdParty) {
            const proposalThirdParty = thirdParty.proposalThirdParties.find(({ proposalTrackingID }) => proposalTrackingID === quote.id);

            this.setState({
                role: proposalThirdParty && proposalThirdParty.thirdPartyRole || proposalThirdParty
            });
        } else {
            this.setState({
                role: null
            });
        }

    }

    render() {
        return (
            <InnerCard>
                <Info label="Third Party">
                    <ThirdPartyLink thirdPartyNumber={this.props.thirdParty.number} />
                </Info>
                <Info label="ICS ID">{this.props.thirdParty.icsID || 'N/A'}</Info>
                <Info contentTitle={`${this.props.thirdParty.country} (${this.props.thirdParty.countryCode})`} label="Country">{this.props.thirdParty.country}</Info>
                <Info label="Message">
                    <Status errorMessage={this.props.thirdParty.errorMessage} includeID statusID={this.props.thirdParty.statusID} thirdParty />
                </Info>

                <Info label="Message Details">                
                    <AlfaMessageDialog msg={this.props.thirdParty.alfaMessage?this.props.thirdParty.messageDetails:'-'} />
                </Info>
             
                <Info label="Role">{this.state.role}</Info>
                <Info label="Created Date">
                    {this.props.quote.createdDate ? (
                        <Moment format="MMMM Do, YYYY">{this.props.quote.createdDate}</Moment>
                    ) : 'N/A'}
                </Info>
                <Info label="Updated Date">
                    {this.props.quote.updatedDate ? (
                        <Moment format="MMMM Do, YYYY">{this.props.quote.updatedDate}</Moment>
                    ) : 'N/A'}
                </Info>
                <Grid container justify="flex-end" spacing={3}>
                    <Grid item>
                        <HistoryDialog thirdParty={this.props.thirdParty} />
                    </Grid>
                </Grid>
            </InnerCard>
        )
    }
}
